import React from 'react';
import PropTypes from 'prop-types';

import LabelWrapper from '../../LabelWrapper';
import { Select } from '../../Select';
import { surveyTypeValues } from '../../../constants/types';

import styles from './surveyPartTypeSelect.module.css';
import { withLang } from '../../../i18n';

const SurveyPartTypeSelect = ({ selectedType, onChange, translate: t }) => (
  <div className={styles.typeFilter} data-cy="browse-survey-parts">
    <LabelWrapper label={t('selectSchemaTypeDialog.title')}>
      <div data-cy="browse-survey-parts-input">
        <Select
          options={[...(Object.values(surveyTypeValues)), 'NOT_DEFINED'].map((surveyType) => ({
            value: surveyType,
            label: t(`surveyType.${surveyType}`)
          }))}
          placeholderKey="common.select"
          value={selectedType}
          onChange={(value) => onChange(value)}
        />
      </div>
    </LabelWrapper>
  </div>
);

const { func, oneOf } = PropTypes;
SurveyPartTypeSelect.propTypes = {
  selectedType: oneOf(Object.values(surveyTypeValues)).isRequired,
  onChange: func.isRequired,
  translate: func.isRequired
};

export default withLang(SurveyPartTypeSelect);
